import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Stack } from '@mui/material';

const PIECES = [
  { code: 'q', label: 'Queen' },
  { code: 'r', label: 'Rook' },
  { code: 'b', label: 'Bishop' },
  { code: 'n', label: 'Knight' },
];

// Piece picker shown when a pawn promotes on the drag board.
export default function PromotionDialog({ open, onSelect }) {
  return (
    <Dialog open={open}>
      <DialogTitle>Promote to</DialogTitle>
      <Stack direction="row" spacing={1} sx={{ p: 2 }}>
        {PIECES.map((p) => (
          <Button key={p.code} variant="outlined" onClick={() => onSelect(p.code)}>
            {p.label}
          </Button>
        ))}
      </Stack>
    </Dialog>
  );
}
